/**
 * Confirmação da recusa, aberta pelo "Não quero manter" do Step 0.
 *
 * A recusa consome o token (spec §5): não há como voltar ao formulário depois.
 * Por isso a ação passa por uma confirmação explícita em vez de disparar direto
 * do botão — o texto diz o que é irreversível antes de o titular decidir.
 */

import { Alert } from "@mui/material";

import { Modal } from "v2/components/Modal";

import { Button, Header, Paragraph, Row, Stack } from "../styled";

interface IProps {
  open: boolean;
  /** Bloqueia os botões enquanto o POST /decline está em voo. */
  isBusy: boolean;
  /** Mensagem de falha da recusa; o modal permanece aberto para nova tentativa. */
  errorMessage?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function DeclineConfirmModal({
  open,
  isBusy,
  errorMessage,
  onConfirm,
  onCancel,
}: IProps) {
  return (
    <Modal
      open={open}
      size="sm"
    >
      <Stack $gap="16px">
        <Header>Confirmar recusa?</Header>

        <Paragraph>
          Ao recusar, você perde o direito de manter o plano por esta oferta e
          não será possível reabrir este formulário.
        </Paragraph>

        {!!errorMessage && <Alert severity="error">{errorMessage}</Alert>}

        <Row
          $gap="8px"
          $justify="flex-end"
        >
          <Button
            variant="outlined"
            onClick={onCancel}
            disabled={isBusy}
          >
            Voltar
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={onConfirm}
            disabled={isBusy}
          >
            {isBusy ? "Enviando..." : "Confirmar recusa"}
          </Button>
        </Row>
      </Stack>
    </Modal>
  );
}
